import { useEffect } from 'react'
import { Alert } from 'reactstrap'

export default function AppObjectError({ errors, parentObjectId }) {
  console.log('AppObjectError rendered', errors, parentObjectId)

  useEffect(() => {
    if (errors && !parentObjectId) {
      //document.querySelector('#app-object-alert').scrollIntoView({ behavior: 'smooth' })
      document.querySelector('#app-object-scroll-container').scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  }, [errors, parentObjectId])

  let errorComponent = ''
  let errorText = ''
  if (errors) {
    if (Array.isArray(errors)) {
      errorText = []
      for (let i = 0; i < errors.length; i++) {
        errorText.push(<p style={{ marginBottom: '0px'}} key={i}>- {errors[i]}</p>)
      }
    } else {
      errorText = errors
    }
    errorComponent = <Alert id="app-object-alert" style={{ display: 'inline-block' }} data-cy="app-object-error" color="danger">{errorText}</Alert>
  }
  return (
    errorComponent
  )
}
